import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import { setLoginOpen, selectLoginOpen, loginSuccess, setReturnLocation, selectReturnLocation } from '../../shared/atoll/redux/authSlice';
import { useNavigate } from 'react-router-dom';
import { AuthedUser } from '../../shared/types/types';
import { useAppDispatch, useAppSelector } from '../../shared/services/redux/hooks';
import { authenticateUser, fnUserLoggedOut } from '../../shared/atoll/atollAuth';

export const Login = ({ returnPath }: { returnPath: string }): null => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setReturnLocation(returnPath));
    dispatch(setLoginOpen(true));
  }, [dispatch, navigate, returnPath]);

  return null;
};

export function LoginDialog() {
  const dispatch = useAppDispatch();
  const open = useAppSelector(selectLoginOpen);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleClose = () => {
    dispatch(setLoginOpen(false));
  };
  const [usernameFocused, setUsernameFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [manualLogin, setManualLogin] = useState(false);

  const handleLogin = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault();
      setManualLogin(true);
    }

    if ((username && password && !usernameFocused && !passwordFocused) || manualLogin) {
      authenticateUser(username, password, _fnCBLoginOutcome, dispatch);
      dispatch(setLoginOpen(false));
    }

    if (manualLogin) {
      setManualLogin(false);
    }
  };

  useEffect(() => {
    handleLogin();
  }, [username, password]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLogin();
    }
  };

  function _fnCBLoginOutcome(success: boolean, data: any): void {
    if (!success) {
      let oError = document.getElementById("inp_loginuser_error");
      if (oError) {
        oError.innerText = data.error || "Unexpected error"
        oError.parentElement!.classList.remove("hide")
      };
    } else {
      try {
        if (data.user) {
          dispatch(loginSuccess(data.user as AuthedUser));
        } else {
          throw new Error('Login response missing user');
        }
      } catch (oError) {
        fnUserLoggedOut()
      }
    };
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Login</DialogTitle>
      <form onSubmit={handleLogin}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="username"
            name="username"
            label="Username"
            type="text"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onFocus={() => setUsernameFocused(true)}
            onBlur={() => setUsernameFocused(false)}
            onKeyDown={handleKeyDown}
            autoComplete="username"
          />
          <TextField
            margin="dense"
            id="password"
            name="password"
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={() => setPasswordFocused(true)}
            onBlur={() => setPasswordFocused(false)}
            onKeyDown={handleKeyDown}
            autoComplete="current-password"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Login
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
